export const loadSvg = async (src: string = "/svg/graph/eclipse.svg", asDataImage = false) => {
	try {
		const response = await fetch(src);
		const content = await response.text();
		const sanitizedContent = content.replace('<svg', '<svg preserveAspectRatio="xMidYMid meet"');
		let svg = sanitizedContent;
		if (asDataImage) {
			svg = 'data:image/svg+xml;base64,' + btoa(sanitizedContent);
		}
		return svg;
	} catch (err) {
		console.error('Error loading SVG:', err);
	}
	return '';
};
